import $ from 'jquery';
import UIkit from 'uikit';

window.addEventListener('px-ready',function () {
    if($('.post-type-archive-uni_product').length>0){
        refreshMailShareLink();
        $('.px-checkbox.is-likes,.px-card-product .like').click(function(){
            refreshMailShareLink();
        })
        window.setTimeout(function(){
            refreshMailShareLink();
        },100);
    }
})

function refreshMailShareLink(){
    if($("#favorites").prop('checked')){
        var value = $('.px-checkbox.is-likes input[type="checkbox"]').attr('value');
        value = value.split(',');
        var links = '';
        value.forEach(function(entry){
            var currURL = $('article[data-id="'+entry+'"]').find('a').attr('href');
            var homeURL = $('.sharebox [network="Email"]').attr("data-homeurl");
            /*data-homeurl
            if(currURL){
                //links += currURL + '%0D%0A';
                links += homeURL + '?p=' + entry + '%0D%0A';
            }*/
        })
        $('.sharebox [network="Email"]').attr('href',"mailto:?subject="+$('.sharebox [network="Email"]').attr("data-subject")+"&body="+links)
    }else{
        $('.sharebox [network="Email"]').attr('href',"mailto:?subject="+$('.sharebox [network="Email"]').attr("data-subject")+"&body="+window.location)
        //window.location
        //mailto:?subject=Tommasi Ripasso Valpolicella - Univins&body=//192.168.1.185:3000/produit/
    }
}
